import { useCustomerState } from '@olo-web/client-state';

export const useIsLoggedIn = (): boolean => {
  const { sessionId } = useCustomerState();
  return !!sessionId;
};
